var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c("b-form-file", {
        staticClass: "upload-box text-nowrap text-truncate",
        attrs: {
          size: "lg",
          placeholder: "Choose or Drop file here",
          "drop-placeholder": "Drop file here"
        },
        on: {
          input: function($event) {
            return _vm.select()
          }
        },
        model: {
          value: _vm.uploadFile,
          callback: function($$v) {
            _vm.uploadFile = $$v
          },
          expression: "uploadFile"
        }
      }),
      _vm._v(" "),
      _c("table", [
        _c("tr", [
          _vm._m(1),
          _vm._v(" "),
          _c("td", { staticStyle: { width: "90%" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filename,
                  expression: "filename"
                }
              ],
              staticStyle: { width: "100%" },
              domProps: { value: _vm.filename },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.filename = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm._m(2),
          _vm._v(" "),
          _c("td", [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.notes,
                  expression: "notes"
                }
              ],
              staticStyle: {
                width: "100%",
                "min-height": "30px",
                height: "60px",
                "max-height": "125px"
              },
              domProps: { value: _vm.notes },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.notes = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.uploadFile != null
        ? _c("img", {
            staticStyle: { width: "30%" },
            attrs: { id: "file_upload", src: "#" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "uploading-box", class: { hidden: !_vm.loading } },
        [
          _c("div", {
            staticClass: "uploading-bar-green",
            attrs: { id: "loading-progress" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          class: { hidden: _vm.uploading },
          attrs: { disabled: !_vm.ready },
          on: {
            click: function($event) {
              return _vm.upload()
            }
          }
        },
        [_vm._v("Upload")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "uploading-box", class: { hidden: !_vm.uploading } },
        [
          _c(
            "div",
            { staticClass: "uploading-bar", attrs: { id: "progress" } },
            [
              _c("p", {
                staticClass: "upload-text",
                attrs: { id: "progress-text" }
              })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Upload Tech Document")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("b", { staticStyle: { "white-space": "nowrap" } }, [
        _vm._v("File Name")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("b", { staticStyle: { "white-space": "nowrap" } }, [_vm._v("Notes")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a28f7a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a28f7a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/add/Add_Techdocs.vue
// module id = 639
// module chunks = 0